import React from 'react'

export default class IconsDnDCheckBox extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M14 7.104V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H11.5627'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M6 7.33341L8 9.33341L14.6667 2.66675'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
